/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-menu":"index__c-menu___4Vp4s","is-open":"index__is-open___1o31H","c-menu--down":"index__c-menu--down___1T3dw","zd-menu--down-open":"index__zd-menu--down-open___1zb2N","zd-menu--down-open-arrow":"index__zd-menu--down-open-arrow___1lssi","c-menu--left":"index__c-menu--left___LrfG3","zd-menu--left-open":"index__zd-menu--left-open___34J1h","zd-menu--left-open-arrow":"index__zd-menu--left-open-arrow___MiyXP","c-menu--right":"index__c-menu--right___1gHc7","zd-menu--right-open":"index__zd-menu--right-open___1Wp4H","zd-menu--right-open-arrow":"index__zd-menu--right-open-arrow___2thrS","c-menu--up":"index__c-menu--up___HD-ee","zd-menu--up-open":"index__zd-menu--up-open___3qIiH","zd-menu--up-open-arrow":"index__zd-menu--up-open-arrow___1V5_a","is-rtl":"index__is-rtl___1KUm_","c-menu__item":"index__c-menu__item___1VmSc","c-menu--sm":"index__c-menu--sm___4G5df","c-menu__item--add":"index__c-menu__item--add___3ZqhT","c-menu__item--header":"index__c-menu__item--header___2OHN9","c-menu__item--previous":"index__c-menu__item--previous___3synr","c-menu__item--header__icon":"index__c-menu__item--header__icon___2H0uX","c-menu__item--next":"index__c-menu__item--next___1je1H","is-checked":"index__is-checked___1Zp9_","c-menu__item__meta":"index__c-menu__item__meta___2MCtT","c-menu__item--media":"index__c-menu__item--media___2UFHl","c-menu__item--media__figure":"index__c-menu__item--media__figure___1a6W9","c-menu__item--media__body":"index__c-menu__item--media__body___2GZE7","is-focused":"index__is-focused___g7yDa","is-hovered":"index__is-hovered___3cIPG","is-active":"index__is-active___2cEA7","is-disabled":"index__is-disabled___2n_jm","is-expanded":"index__is-expanded___2a5Ba","is-hidden":"index__is-hidden___12Bww","c-menu__separator":"index__c-menu__separator___2Bzvl"};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-theming");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'menus.item';

/**
 * Accepts all `<li>` props
 */
var Item = _styledComponents2.default.li.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssMenus2.default['c-menu__item'], (_classNames = {}, _defineProperty(_classNames, _cssMenus2.default['is-active'], props.active), _defineProperty(_classNames, _cssMenus2.default['is-focused'], props.focused), _defineProperty(_classNames, _cssMenus2.default['is-hovered'], props.hovered), _defineProperty(_classNames, _cssMenus2.default['is-disabled'], props.disabled), _defineProperty(_classNames, _cssMenus2.default['is-checked'], props.checked), _classNames));
  }
}).withConfig({
  displayName: 'Item'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

Item.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool
};

/** @component */
exports.default = Item;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.previous_item';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var PreviousItem = (0, _styledComponents2.default)(_Item2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--previous']
}).withConfig({
  displayName: 'PreviousItem'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

PreviousItem.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

/** @component */
exports.default = PreviousItem;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.next_item';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var NextItem = (0, _styledComponents2.default)(_Item2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--next']
}).withConfig({
  displayName: 'NextItem'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

NextItem.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

/** @component */
exports.default = NextItem;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.media_item';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var MediaItem = (0, _styledComponents2.default)(_Item2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--media']
}).withConfig({
  displayName: 'MediaItem'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

MediaItem.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool
};

/** @component */
exports.default = MediaItem;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.add_item';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var AddItem = (0, _styledComponents2.default)(_Item2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--add']
}).withConfig({
  displayName: 'AddItem'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

AddItem.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

/** @component */
exports.default = AddItem;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _cssArrows = __webpack_require__(22);

var _cssArrows2 = _interopRequireDefault(_cssArrows);

var _cssVariables = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'menus.menu_view';

var PLACEMENT = {
  AUTO: 'auto',
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
};

var topAnimation = (0, _styledComponents.keyframes)(['0%{margin-top:', ';}100%{margin-top:8px;}'], _cssVariables.zdSpacing);

var leftAnimation = (0, _styledComponents.keyframes)(['0%{margin-left:', ';}100%{margin-left:8px;}'], _cssVariables.zdSpacing);

var shouldShowArrow = function shouldShowArrow(_ref) {
  var arrow = _ref.arrow,
      placement = _ref.placement;

  return arrow && (placement === PLACEMENT.LEFT || placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_START || placement === PLACEMENT.BOTTOM_END || placement === PLACEMENT.RIGHT || placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END);
};

var retrieveMenuMargin = function retrieveMenuMargin(_ref2) {
  var arrow = _ref2.arrow,
      placement = _ref2.placement;

  var marginAmount = shouldShowArrow({ arrow: arrow, placement: placement }) ? '8px' : '4px';

  if (placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_START || placement === PLACEMENT.BOTTOM_END) {
    return 'margin-top: ' + marginAmount + ';';
  }

  if (placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END) {
    return 'margin-bottom: ' + marginAmount + ';';
  }

  if (placement === PLACEMENT.LEFT || placement === PLACEMENT.LEFT_START || placement === PLACEMENT.LEFT_END) {
    return 'margin-right: ' + marginAmount + ';';
  }

  if (placement === PLACEMENT.RIGHT || placement === PLACEMENT.RIGHT_START || placement === PLACEMENT.RIGHT_END) {
    return 'margin-left: ' + marginAmount + ';';
  }

  return '';
};

/**
 * We must provide our own top and left animation to allow
 * Popper.js to position correctly
 */
var retrieveAnimation = function retrieveAnimation(_ref3) {
  var animate = _ref3.animate,
      placement = _ref3.placement;

  if (!animate) {
    return '';
  }

  if (placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END) {
    return 'animation: ' + topAnimation;
  }

  if (placement === PLACEMENT.LEFT || placement === PLACEMENT.LEFT_START || placement === PLACEMENT.LEFT_END) {
    return 'animation: ' + leftAnimation;
  }

  return '';
};

/**
 * Accepts all `<ul>` props
 */
var StyledMenuView = _styledComponents2.default.ul.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssMenus2.default['c-menu'], (_classNames = {}, _defineProperty(_classNames, _cssMenus2.default['c-menu--sm'], props.small), _defineProperty(_classNames, _cssMenus2.default['c-menu--up'], props.placement === PLACEMENT.TOP || props.placement === PLACEMENT.TOP_START || props.placement === PLACEMENT.TOP_END), _defineProperty(_classNames, _cssMenus2.default['c-menu--right'], props.placement === PLACEMENT.RIGHT || props.placement === PLACEMENT.RIGHT_START || props.placement === PLACEMENT.RIGHT_END), _defineProperty(_classNames, _cssMenus2.default['c-menu--left'], props.placement === PLACEMENT.LEFT || props.placement === PLACEMENT.LEFT_START || props.placement === PLACEMENT.LEFT_END), _defineProperty(_classNames, _cssMenus2.default['c-menu--down'], props.placement === PLACEMENT.BOTTOM || props.placement === PLACEMENT.BOTTOM_START || props.placement === PLACEMENT.BOTTOM_END), _defineProperty(_classNames, _cssMenus2.default['is-open'], props.animate), _defineProperty(_classNames, _cssMenus2.default['is-hidden'], props.hidden), _defineProperty(_classNames, _cssArrows2.default['c-arrow'], shouldShowArrow(props)), _defineProperty(_classNames, _cssArrows2.default['c-arrow--r'], props.placement === PLACEMENT.LEFT), _defineProperty(_classNames, _cssArrows2.default['c-arrow--b'], props.placement === PLACEMENT.TOP), _defineProperty(_classNames, _cssArrows2.default['c-arrow--bl'], props.placement === PLACEMENT.TOP_START), _defineProperty(_classNames, _cssArrows2.default['c-arrow--br'], props.placement === PLACEMENT.TOP_END), _defineProperty(_classNames, _cssArrows2.default['c-arrow--l'], props.placement === PLACEMENT.RIGHT), _defineProperty(_classNames, _cssArrows2.default['c-arrow--t'], props.placement === PLACEMENT.BOTTOM), _defineProperty(_classNames, _cssArrows2.default['c-arrow--tl'], props.placement === PLACEMENT.BOTTOM_START), _defineProperty(_classNames, _cssArrows2.default['c-arrow--tr'], props.placement === PLACEMENT.BOTTOM_END), _defineProperty(_classNames, _cssMenus2.default['is-rtl'], (0, _reactTheming.isRtl)(props)), _classNames));
  }
}).withConfig({
  displayName: 'MenuView__StyledMenuView'
})(['&&{', ';position:relative;}:focus{outline:none;}', ';'], retrieveAnimation, function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

var MenuWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'MenuView__MenuWrapper'
})(['', ';'], retrieveMenuMargin);

var MenuView = function MenuView(props) {
  var arrow = props.arrow,
      placement = props.placement;

  var menuRef = props.menuRef,
      otherRefs = _objectWithoutProperties(props, ['menuRef']);

  return _react2.default.createElement(
    MenuWrapper,
    { arrow: arrow, placement: placement },
    _react2.default.createElement(StyledMenuView, _extends({ innerRef: menuRef }, otherRefs))
  );
};

MenuView.propTypes = {
  /**
   * All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements)
   */
  placement: _propTypes2.default.oneOf([PLACEMENT.AUTO, PLACEMENT.TOP, PLACEMENT.TOP_START, PLACEMENT.TOP_END, PLACEMENT.RIGHT, PLACEMENT.RIGHT_START, PLACEMENT.RIGHT_END, PLACEMENT.BOTTOM, PLACEMENT.BOTTOM_START, PLACEMENT.BOTTOM_END, PLACEMENT.LEFT, PLACEMENT.LEFT_START, PLACEMENT.LEFT_END]),
  animate: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  arrow: _propTypes2.default.bool,
  /**
   * Ref of internal Menu container
   */
  menuRef: _propTypes2.default.func
};

/** @component */
exports.default = MenuView;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-selection");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactPopper = __webpack_require__(28);

var _reactPortal = __webpack_require__(27);

var _reactSelection = __webpack_require__(12);

var _reactTooltips = __webpack_require__(26);

var _reactTheming = __webpack_require__(1);

var _reactModals = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * This container must provide a wrapper for the provided menu
 * due to constraints in our arrow css. We must ensure that the container
 * of the menu can retain its relative positioning. Without this
 * container Popper would apply absolute positioning.
 */
var MenuWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'MenuContainer__MenuWrapper'
})(['z-index:', ';'], function (props) {
  return props.zIndex;
});

var MenuContainer = function (_ControlledComponent) {
  _inherits(MenuContainer, _ControlledComponent);

  function MenuContainer() {
    var _ref;

    _classCallCheck(this, MenuContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = MenuContainer.__proto__ || Object.getPrototypeOf(MenuContainer)).call.apply(_ref, [this].concat(args)));

    _this.handleOutsideMouseDown = function (event) {
      var _this$getControlledSt = _this.getControlledState(),
          isOpen = _this$getControlledSt.isOpen;

      if (!isOpen) {
        return;
      }

      if (_this.menuReference && !_this.menuReference.contains(event.target)) {
        if (_this.triggerReference && !_this.triggerReference.contains(event.target)) {
          _this.toggleMenuVisibility({ closedByBlur: true });
        }
      }
    };

    _this.getMenuId = function () {
      return _this.getControlledState().id + '--container';
    };

    _this.toggleMenuVisibility = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          defaultFocusedIndex = _ref2.defaultFocusedIndex,
          focusOnOpen = _ref2.focusOnOpen,
          closedByBlur = _ref2.closedByBlur;

      var _this$getControlledSt2 = _this.getControlledState(),
          isOpen = _this$getControlledSt2.isOpen;

      _this.setControlledState({
        isOpen: !isOpen,
        focusedKey: undefined,
        defaultFocusedIndex: defaultFocusedIndex,
        focusOnOpen: focusOnOpen,
        closedByBlur: closedByBlur
      });
    };

    _this.getTriggerProps = function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref3$tabIndex = _ref3.tabIndex,
          tabIndex = _ref3$tabIndex === undefined ? 0 : _ref3$tabIndex,
          onClick = _ref3.onClick,
          onKeyDown = _ref3.onKeyDown,
          other = _objectWithoutProperties(_ref3, ['tabIndex', 'onClick', 'onKeyDown']);

      var _this$getControlledSt3 = _this.getControlledState(),
          isOpen = _this$getControlledSt3.isOpen;

      return _extends({
        tabIndex: tabIndex,
        'aria-haspopup': true,
        'aria-controls': _this.getMenuId(),
        'aria-expanded': isOpen,
        onClick: (0, _reactSelection.composeEventHandlers)(onClick, function () {
          return _this.toggleMenuVisibility();
        }),
        onKeyDown: (0, _reactSelection.composeEventHandlers)(onKeyDown, function (event) {
          var _VALID_OPEN_KEYS;

          var VALID_OPEN_KEYS = (_VALID_OPEN_KEYS = {}, _defineProperty(_VALID_OPEN_KEYS, _reactSelection.KEY_CODES.ENTER, true), _defineProperty(_VALID_OPEN_KEYS, _reactSelection.KEY_CODES.SPACE, true), _defineProperty(_VALID_OPEN_KEYS, _reactSelection.KEY_CODES.UP, true), _defineProperty(_VALID_OPEN_KEYS, _reactSelection.KEY_CODES.DOWN, true), _VALID_OPEN_KEYS);

          if (event.keyCode in VALID_OPEN_KEYS) {
            _this.toggleMenuVisibility({
              defaultFocusedIndex: event.keyCode === _reactSelection.KEY_CODES.UP ? -1 : 0,
              focusOnOpen: true
            });

            event.preventDefault();
            event.stopPropagation();
          }
        })
      }, other);
    };

    _this.triggerRef = function (reference) {
      if (reference) {
        _this.triggerReference = reference;
      }
    };

    _this.menuRef = function (reference) {
      if (reference) {
        _this.menuReference = reference;
      }
    };

    _this.onItemSelected = function (itemKey) {
      var onChange = _this.props.onChange;


      onChange && onChange(itemKey);
    };

    _this.getMenuProps = function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var focusSelectionModel = arguments[1];

      var _ref4$id = _ref4.id,
          id = _ref4$id === undefined ? _this.getMenuId() : _ref4$id,
          _ref4$tabIndex = _ref4.tabIndex,
          tabIndex = _ref4$tabIndex === undefined ? -1 : _ref4$tabIndex,
          _ref4$role = _ref4.role,
          role = _ref4$role === undefined ? 'menu' : _ref4$role,
          onKeyDown = _ref4.onKeyDown,
          onFocus = _ref4.onFocus,
          other = _objectWithoutProperties(_ref4, ['id', 'tabIndex', 'role', 'onKeyDown', 'onFocus']);

      var _this$getControlledSt4 = _this.getControlledState(),
          focusOnOpen = _this$getControlledSt4.focusOnOpen;

      return _extends({
        id: id,
        role: role,
        tabIndex: tabIndex,
        onFocus: (0, _reactSelection.composeEventHandlers)(onFocus, function (event) {
          /**
           * If the Menu has been opened by a mouse we want to stop
           * the focus event from triggering the default focusing logic.
           */
          if (!focusOnOpen) {
            event.preventDefault();
          }
        }),
        onKeyDown: (0, _reactSelection.composeEventHandlers)(onKeyDown, function (event) {
          var _this$getControlledSt5 = _this.getControlledState(),
              focusedKey = _this$getControlledSt5.focusedKey;

          if (event.keyCode === _reactSelection.KEY_CODES.TAB) {
            if (event.shiftKey) {
              focusSelectionModel.selectPrevious();
            } else {
              focusSelectionModel.selectNext();
            }

            event.preventDefault();
            event.stopPropagation();

            return;
          }

          /**
           * Close menu on ESCAPE
           */
          if (event.keyCode === _reactSelection.KEY_CODES.ESCAPE) {
            _this.toggleMenuVisibility();
            event.preventDefault();
            event.stopPropagation();

            return;
          }

          if (event.keyCode === _reactSelection.KEY_CODES.RIGHT) {
            var directionalKey = (0, _reactTheming.isRtl)(_this.props) ? _this.previousKey : _this.nextKeys[focusedKey] && focusedKey;

            if (directionalKey) {
              _this.onItemSelected(directionalKey);
              event.preventDefault();
              event.stopPropagation();

              return;
            }
          }

          if (event.keyCode === _reactSelection.KEY_CODES.LEFT) {
            var _directionalKey = (0, _reactTheming.isRtl)(_this.props) ? _this.nextKeys[focusedKey] && focusedKey : _this.previousKey;

            if (_directionalKey) {
              _this.onItemSelected(_directionalKey);
              event.preventDefault();
              event.stopPropagation();

              return;
            }
          }

          if (event.keyCode !== _reactSelection.KEY_CODES.ALT) {
            var charString = event.key;
            var matchingSelectionModel = _this.textValueSelectionModels[charString.toLocaleUpperCase()];

            if (matchingSelectionModel) {
              matchingSelectionModel.selectionModel.selectNext();
              var matchingKey = matchingSelectionModel.keys[matchingSelectionModel.selectionModel.selectedIndex];

              _this.setControlledState({
                focusedKey: matchingKey
              });
            }
          }
        })
      }, other);
    };

    _this.getItemProps = function (_ref5) {
      var key = _ref5.key,
          textValue = _ref5.textValue,
          other = _objectWithoutProperties(_ref5, ['key', 'textValue']);

      var _this$getControlledSt6 = _this.getControlledState(),
          focusedKey = _this$getControlledSt6.focusedKey;

      if (typeof textValue === 'string' && textValue.length > 0) {
        var firstChar = textValue.toLocaleUpperCase().charAt(0);

        if (!_this.textValueSelectionModels[firstChar]) {
          _this.textValueSelectionModels[firstChar] = {
            keys: [],
            selectionModel: new _reactSelection.SingleSelectionModel()
          };
        }

        var currentSelectionModel = _this.textValueSelectionModels[firstChar];

        currentSelectionModel.keys.push(key);
        currentSelectionModel.selectionModel.numItems++;

        if (key === focusedKey) {
          var focusedIndex = currentSelectionModel.keys.length - 1;

          currentSelectionModel.selectionModel.select(focusedIndex);
        }
      }

      return _extends({
        key: key
      }, other);
    };

    _this.getNextItemProps = function () {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var key = _ref6.key,
          other = _objectWithoutProperties(_ref6, ['key']);

      _this.nextKeys[key] = true;

      return _extends({
        key: key,
        'aria-expanded': false
      }, other);
    };

    _this.getPreviousItemProps = function () {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var key = _ref7.key,
          other = _objectWithoutProperties(_ref7, ['key']);

      _this.previousKey = key;

      return _extends({
        key: key,
        'aria-expanded': true
      }, other);
    };

    _this.convertGardenToPopperPlacement = function () {
      var placement = _this.props.placement;


      if ((0, _reactTheming.isRtl)(_this.props)) {
        return (0, _reactTooltips.getRtlPopperPlacement)(placement);
      }

      return (0, _reactTooltips.getPopperPlacement)(placement);
    };

    _this.state = {
      isOpen: false,
      id: _reactSelection.IdManager.generateId(),
      focusedKey: undefined,
      selectedKey: undefined,
      focusOnOpen: undefined,
      closedByBlur: undefined,
      defaultFocusedIndex: 0
    };
    return _this;
  }

  _createClass(MenuContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleOutsideMouseDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutsideMouseDown);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _getControlledState = this.getControlledState(),
          isOpen = _getControlledState.isOpen,
          closedByBlur = _getControlledState.closedByBlur;

      var previousisOpen = this.isControlledProp('isOpen') ? prevProps.isOpen : prevState.isOpen;

      /**
       * Focus trigger element when menu is closed from selection or ESC key
       */
      if (!isOpen && previousisOpen) {
        if (!closedByBlur) {
          this.triggerReference && this.triggerReference.focus();
        }
      }

      /**
       * Focus menu element when opened
       */
      if (isOpen && !previousisOpen) {
        if (!this.menuReference) {
          throw new Error('Accessibility Error: You must apply the `menuRef` prop to the element that contains your menu.');
        }

        /**
         * Delaying the menu focus allows Popper.JS to reflow positioning based on boundary collisions.
         * Without this delay the focus event will cause any overflowed area to scroll.
         */
        setTimeout(function () {
          _this2.menuReference && _this2.menuReference.focus();
        }, 0);
      }
    }

    /**
     * Used to know when a Menu is blured by mouse
     */


    /**
     * Props to be applied to the trigger element
     */


    /**
     * Triggers callback to signal that an item has been selected
     */


    /**
     * Props to be applied to the menu container
     */


    /**
     * Props to be applied to each selectable menu item
     **/


    /**
     * Props to be applied to each menu item that contains children
     **/


    /**
     * Props to be applied to each menu item that links to a parent
     **/


    /**
     * Convert RTL-aware Garden placements to PopperJS placements
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          _props$render = _props.render,
          render = _props$render === undefined ? children : _props$render,
          trigger = _props.trigger,
          eventsEnabled = _props.eventsEnabled,
          popperModifiers = _props.popperModifiers,
          appendToNode = _props.appendToNode,
          zIndex = _props.zIndex;

      var _getControlledState2 = this.getControlledState(),
          isOpen = _getControlledState2.isOpen,
          controlledFocusedKey = _getControlledState2.focusedKey,
          controlledSelectedKey = _getControlledState2.selectedKey,
          id = _getControlledState2.id,
          defaultFocusedIndex = _getControlledState2.defaultFocusedIndex;

      this.textValueSelectionModels = {};
      this.nextKeys = {};
      this.previousKey = undefined;

      /**
       * We must decide whether the provided `selectedKey` is controlled
       */
      var selectedKey = this.isControlledProp('selectedKey') ? controlledSelectedKey : undefined;

      return _react2.default.createElement(
        _reactPopper.Manager,
        { tag: false },
        _react2.default.createElement(
          _reactPopper.Target,
          null,
          function (_ref8) {
            var targetProps = _ref8.targetProps;
            var targetRef = targetProps.ref;


            return trigger && trigger({
              getTriggerProps: function getTriggerProps(props) {
                return _this3.getTriggerProps(_extends({}, props));
              },
              triggerRef: function triggerRef(ref) {
                targetRef(ref);
                _this3.triggerRef(ref);
              }
            });
          }
        ),
        _react2.default.createElement(
          _reactPopper.Popper,
          {
            placement: this.convertGardenToPopperPlacement(),
            eventsEnabled: eventsEnabled,
            modifiers: popperModifiers
          },
          function (_ref9) {
            var popperProps = _ref9.popperProps,
                scheduleUpdate = _ref9.scheduleUpdate;

            var popperPlacement = popperProps['data-placement'];
            var outOfBoundaries = popperProps['data-x-out-of-boundaries'];

            if (!isOpen) {
              return false;
            }

            var menu = _react2.default.createElement(
              MenuWrapper,
              { innerRef: popperProps.ref, style: popperProps.style, zIndex: zIndex },
              _react2.default.createElement(
                _reactModals.FocusJailContainer,
                { focusOnMount: false },
                function (_ref10) {
                  var getFocusJailContainerProps = _ref10.getContainerProps,
                      containerRef = _ref10.containerRef;
                  return _react2.default.createElement(
                    _reactSelection.SelectionContainer,
                    {
                      id: id,
                      direction: 'vertical',
                      focusedKey: controlledFocusedKey,
                      selectedKey: selectedKey,
                      defaultFocusedIndex: defaultFocusedIndex,
                      onStateChange: function onStateChange(newState) {
                        /**
                         * We only care if `selectedKey` is involved with the state change
                         */
                        if (Object.prototype.hasOwnProperty.call(newState, 'selectedKey')) {
                          var newSelectedKey = newState.selectedKey;

                          if (newSelectedKey === undefined) {
                            newSelectedKey = selectedKey;
                          }

                          _this3.onItemSelected(newSelectedKey);

                          if (newState.selectedKey === undefined) {
                            newState.isOpen = false;
                          } else {
                            newState.isOpen = _this3.nextKeys[newState.selectedKey] || _this3.previousKey === newState.selectedKey;
                          }
                        }

                        _this3.setControlledState(newState);
                      }
                    },
                    function (_ref11) {
                      var getContainerProps = _ref11.getContainerProps,
                          getSelectionItemProps = _ref11.getItemProps,
                          focusedKey = _ref11.focusedKey,
                          focusSelectionModel = _ref11.focusSelectionModel;
                      return render({
                        getMenuProps: function getMenuProps(props) {
                          return getFocusJailContainerProps(getContainerProps(_this3.getMenuProps(props, focusSelectionModel)));
                        },
                        getItemProps: function getItemProps(props) {
                          return getSelectionItemProps(_this3.getItemProps(props));
                        },
                        getNextItemProps: function getNextItemProps(props) {
                          return getSelectionItemProps(_this3.getItemProps(_this3.getNextItemProps(props)));
                        },
                        getPreviousItemProps: function getPreviousItemProps(props) {
                          return getSelectionItemProps(_this3.getItemProps(_this3.getPreviousItemProps(props)));
                        },
                        menuRef: function menuRef(ref) {
                          containerRef(ref);
                          _this3.menuRef(ref);
                        },
                        placement: popperPlacement,
                        outOfBoundaries: outOfBoundaries,
                        scheduleUpdate: scheduleUpdate,
                        focusedKey: focusedKey
                      });
                    }
                  );
                }
              )
            );

            if (appendToNode) {
              menu = _react2.default.createElement(
                _reactPortal.Portal,
                { node: appendToNode },
                menu
              );
            }

            return menu;
          }
        )
      );
    }
  }]);

  return MenuContainer;
}(_reactSelection.ControlledComponent);

MenuContainer.propTypes = {
  /**
   * Appends the menu to the provided element
   */
  appendToNode: _propTypes2.default.instanceOf(Element),
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getMenuProps - Props to be spread onto the containing menu element
   * @param {Function} renderProps.getItemProps - Props to be spread each selectable menu item. `({ key })` is required
   * @param {Function} renderProps.getNextItemProps - Props to be spread each next menu item. `({ key })` is required
   * @param {Function} renderProps.getPreviousItemProps - Props to be spread each previous menu item. `({ key })` is required
   * @param {Any} renderProps.menuRef - Callback for the ref of the element containing the menu items
   * @param {Any} renderProps.placement - The current Popper.JS placement of the Menu. Will update based on boundary conflicts.
   * @param {Any} renderProps.outOfBoundaries - Whether the current menu has escaped its boundary.
   * @param {Any} renderProps.scheduleUpdate - Method to force an update within Popper.js
   * @param {Any} renderProps.focusedKey - The currently focused key that was provided to `getItemProps()`
   */
  children: _propTypes2.default.func,
  /**
   * Callback for when a menu item has been selected by keyboard or mouse
   * @param {String} selectedKey - The key of the selected item
   */
  onChange: _propTypes2.default.func,
  /**
   * Whether Popper.js should update based on DOM resize events
   */
  eventsEnabled: _propTypes2.default.bool,
  /**
   * The root ID to use for descendants. A unique ID is created if none is provided.
   */
  id: _propTypes2.default.string,
  /**
   * Controls visibility of menu
   */
  isOpen: _propTypes2.default.bool,
  /**
   * The currently focused item
   */
  focusedKey: _propTypes2.default.string,
  /**
   * The currently selected item.
   *
   * **IMPORTANT:** If you think you should be using this prop,
   * ensure that the @zendeskgarden/react-select package doesn't
   * cover your use case since there may be other accessibility
   * implications.
   */
  selectedKey: _propTypes2.default.string,
  /**
   * Returns all controlled state. Used for controlling usage.
   */
  onStateChange: _propTypes2.default.func,
  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   */
  placement: _propTypes2.default.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),
  /**
   * Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options)
   */
  popperModifiers: _propTypes2.default.object,
  /**
   * Identical to children
   */
  render: _propTypes2.default.func,
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getTriggerProps - Props to be spread onto the trigger element
   * @param {Function} renderProps.triggerRef - Callback for the ref of the element triggering the menu
   * @param {Boolean} renderProps.isOpen - Whether the Menu is currently visible
   */
  trigger: _propTypes2.default.func,
  /**
   * The default index to focus when the menu is opened
   */
  defaultFocusedIndex: _propTypes2.default.number,
  /**
   * The z-index of the popper.js placement container
   */
  zIndex: _propTypes2.default.number
};
MenuContainer.defaultProps = {
  placement: 'bottom-start',
  eventsEnabled: true,
  zIndex: 1000
};
exports.default = (0, _reactTheming.withTheme)(MenuContainer);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.separator';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Separator = _styledComponents2.default.li.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  role: 'separator',
  className: _cssMenus2.default['c-menu__separator']
}).withConfig({
  displayName: 'Separator'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Separator;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var COMPONENT_ID = 'menus.media_figure';

var MediaFigure = function MediaFigure(_ref) {
  var children = _ref.children;

  return _react2.default.cloneElement(_react.Children.only(children), {
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "3.0.1",
    className: _cssMenus2.default['c-menu__item--media__figure']
  });
};

/** @component */
exports.default = MediaFigure;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.media_body';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var MediaBody = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--media__body']
}).withConfig({
  displayName: 'MediaBody'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = MediaBody;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.item_meta';

/**
 * Accepts all `<span>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var ItemMeta = _styledComponents2.default.span.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item__meta']
}).withConfig({
  displayName: 'ItemMeta'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = ItemMeta;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'menus.header_item';

/**
 * Accepts all `<li>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var HeaderItem = (0, _styledComponents2.default)(_Item2.default).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "3.0.1",
  className: _cssMenus2.default['c-menu__item--header']
}).withConfig({
  displayName: 'HeaderItem'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

HeaderItem.propTypes = {
  active: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool
};

/** @component */
exports.default = HeaderItem;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _cssMenus = __webpack_require__(0);

var _cssMenus2 = _interopRequireDefault(_cssMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var COMPONENT_ID = 'menus.header_icon';

var HeaderIcon = function HeaderIcon(_ref) {
  var children = _ref.children;

  return _react2.default.cloneElement(_react.Children.only(children), {
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "3.0.1",
    className: _cssMenus2.default['c-menu__item--header__icon']
  });
};

/** @component */
exports.default = HeaderIcon;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

module.exports = {
  zdColorBlack: '#000',
  zdColorGreen100: '#edf8f4',
  zdColorGreen200: '#d1e8df',
  zdColorGreen300: '#aecfc2',
  zdColorGreen400: '#5eae91',
  zdColorGreen500: '#228f67',
  zdColorGreen600: '#038153',
  zdColorGreen700: '#186146',
  zdColorGreen800: '#0b3b29',
  zdColorGrey100: '#f8f9f9',
  zdColorGrey200: '#e9ebed',
  zdColorGrey300: '#d8dcde',
  zdColorGrey400: '#c2c8cc',
  zdColorGrey500: '#87929d',
  zdColorGrey600: '#68737d',
  zdColorGrey700: '#49545c',
  zdColorGrey800: '#2f3941',
  zdColorBlue100: '#edf7ff',
  zdColorBlue200: '#cee2f2',
  zdColorBlue300: '#adcce4',
  zdColorBlue400: '#5293c7',
  zdColorBlue500: '#337fbd',
  zdColorBlue600: '#1f73b7',
  zdColorBlue700: '#144a75',
  zdColorBlue800: '#0f3554',
  zdColorKale100: '#f5fbfc',
  zdColorKale200: '#c1d6d9',
  zdColorKale300: '#819a9e',
  zdColorKale400: '#56777a',
  zdColorKale500: '#335d63',
  zdColorKale600: '#04444d',
  zdColorKale700: '#03363d',
  zdColorKale800: '#012b30',
  zdColorRed100: '#fff0f1',
  zdColorRed200: '#f5d5d8',
  zdColorRed300: '#f5b5ba',
  zdColorRed400: '#e35b66',
  zdColorRed500: '#d93f4c',
  zdColorRed600: '#cc3340',
  zdColorRed700: '#8c232c',
  zdColorRed800: '#681219',
  zdColorYellow100: '#fff8ed',
  zdColorYellow200: '#fff0db',
  zdColorYellow300: '#fcdba9',
  zdColorYellow400: '#ffb648',
  zdColorYellow500: '#f5a133',
  zdColorYellow600: '#ed961c',
  zdColorYellow700: '#ad5e18',
  zdColorYellow800: '#703b15',
  zdColorWhite: '#fff',
  zdColorAffair: '#734988',
  zdColorAluminum: '#999',
  zdColorAntiFlashWhite: '#f3f3f3',
  zdColorAppleGreen: '#78a300',
  zdColorApricot: '#ffcab3',
  zdColorBlueChalk: '#e5d6ed',
  zdColorBuff: '#f6de86',
  zdColorButtermilk: '#ffefb3',
  zdColorCeSoir: '#9677a6',
  zdColorCgRed: '#e03b30',
  zdColorChateauGreen: '#16ba52',
  zdColorChathamsBlue: '#24536b',
  zdColorColumbiaBlue: '#a8d8ff',
  zdColorCoolBlue: '#0a91ff',
  zdColorCoralCandy: '#efcbc9',
  zdColorCremeBrulee: '#ffdc99',
  zdColorCupid: '#fab4c9',
  zdColorCuriousBlue: '#358fb2',
  zdColorDandelion: '#ffde66',
  zdColorDarkGray: '#555',
  zdColorDarkPastelRed: '#bf3026',
  zdColorDeepLilac: '#965ab6',
  zdColorDenim: '#146eaa',
  zdColorEastSide: '#b083c8',
  zdColorFestival: '#f2ce4a',
  zdColorFlamingo: '#eb6651',
  zdColorGainsboro: '#ddd',
  zdColorGoldenDream: '#efc93d',
  zdColorIndianRed: '#cf645c',
  zdColorIron: '#ccc',
  zdColorJonquil: '#ffdd5f',
  zdColorKarl: '#f3f0ee',
  zdColorLemonChiffon: '#fff3ca',
  zdColorLightCrimson: '#f3749a',
  zdColorLilyWhite: '#ebebeb',
  zdColorLola: '#b9a4c3',
  zdColorMabel: '#cce3ec',
  zdColorMagicMint: '#aaf3c4',
  zdColorMalibu: '#5ebbde',
  zdColorMandy: '#eb4962',
  zdColorMarigold: '#ffc800',
  zdColorMayaBlue: '#61b8ff',
  zdColorMonsoon: '#777',
  zdColorMoonYellow: '#edbe0e',
  zdColorMoonstoneBlue: '#6aabc4',
  zdColorNero: '#1a1a1a',
  zdColorNonPhotoBlue: '#a5dcf2',
  zdColorOasis: '#faefc3',
  zdColorOil: '#333',
  zdColorOrangePeel: '#faa300',
  zdColorPalatinateBlue: '#1438f7',
  zdColorPaleTurquoise: '#aff3ee',
  zdColorPatternsBlue: '#d2eef9',
  zdColorPelorous: '#30aabc',
  zdColorPerano: '#a6b3ff',
  zdColorPerfume: '#caacda',
  zdColorPersianGreen: '#03b3a7',
  zdColorPersimmon: '#ff6d5a',
  zdColorPetiteOrchid: '#df9792',
  zdColorPicasso: '#ffe894',
  zdColorPinkOrange: '#ff9466',
  zdColorPlatinum: '#eee',
  zdColorPortlandOrange: '#ff542e',
  zdColorRazzmatazz: '#f2316b',
  zdColorRegentStBlue: '#9ac7d8',
  zdColorRemy: '#f7cecb',
  zdColorSaffronMango: '#fac157',
  zdColorSeaBuckthorn: '#f79a3e',
  zdColorShamrock: '#45d97b',
  zdColorSilverSand: '#bbb',
  zdColorSkyBlue: '#78cdec',
  zdColorSnow: '#fbfbfb',
  zdColorSteel: '#666',
  zdColorSunglow: '#ffd12a',
  zdColorTerraCotta: '#e86c64',
  zdColorTitanWhite: '#dcd1e1',
  zdColorUltramarineBlue: '#5e76ff',
  zdColorVerdigris: '#37b8af',
  zdColorViking: '#5fd4cc',
  zdColorWewak: '#ef9d97',
  zdColorWhiteSmoke: '#f8f8f8',
  zdColorChatOrange: '#f79a3e',
  zdColorConnectRed: '#eb6651',
  zdColorExploreBlue: '#30aabc',
  zdColorGuidePink: '#eb4962',
  zdColorInboxOrange: '#ff6d5a',
  zdColorMessageGreen: '#37b8af',
  zdColorSupportGreen: '#78a300',
  zdColorTalkYellow: '#efc93d',
  zdColorAlgae: '#03363d',
  zdColorBreakerBay: '#56777a',
  zdColorDaintree: '#012b30',
  zdColorPromoOrange: '#faa300',
  zdColorSherpaBlue: '#04444d',
  zdColorSubmarine: '#819a9e',
  zdColorZendeskGreen: '#78a300',
  zdFontFamilyMonospace: 'SFMono-Regular,Consolas,"Liberation Mono",Menlo,Courier,monospace',
  zdFontFamilySystem: 'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",Arial,sans-serif',
  zdFontSizeGiga: '36px',
  zdFontSizeMega: '28px',
  zdFontSizeKilo: '25px',
  zdFontSizeAlpha: '22px',
  zdFontSizeBeta: '20px',
  zdFontSizeGamma: '18px',
  zdFontSizeDelta: '16px',
  zdFontSizeEpsilon: '14px',
  zdFontSizeZeta: '12px',
  zdFontSizeMilli: '11px',
  zdFontSizeMicro: '10px',
  zdFontSizeNano: '9px',
  zdFontWeightThin: '100',
  zdFontWeightExtralight: '200',
  zdFontWeightLight: '300',
  zdFontWeightRegular: '400',
  zdFontWeightMedium: '500',
  zdFontWeightSemibold: '600',
  zdFontWeightBold: '700',
  zdFontWeightExtrabold: '800',
  zdFontWeightBlack: '900',
  zdFontWeightUltralight: '200',
  zdFontWeightUltrabold: '800',
  zdFontWeightHeavy: '900',
  zdSpacing: '20px',
  zdSpacingLg: '30px',
  zdSpacingSm: '10px',
  zdSpacingXl: '40px',
  zdSpacingXs: '5px',
  zdSpacingXxs: '2px'
};


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-arrow":"index__c-arrow___cuUSh","c-arrow--t":"index__c-arrow--t___1ZWKF","c-arrow--tl":"index__c-arrow--tl___322NF","c-arrow--tr":"index__c-arrow--tr___MeaCx","c-arrow--r":"index__c-arrow--r___1QMUz","c-arrow--rb":"index__c-arrow--rb___1HzLl","c-arrow--rt":"index__c-arrow--rt___1e89v","c-arrow--l":"index__c-arrow--l___1UW5e","c-arrow--lb":"index__c-arrow--lb___1femU","c-arrow--lt":"index__c-arrow--lt___uMq77","c-arrow--b":"index__c-arrow--b___31z-F","c-arrow--bl":"index__c-arrow--bl___Yjbqb","c-arrow--br":"index__c-arrow--br___2cmY-"};

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelection = __webpack_require__(12);

var _MenuContainer = __webpack_require__(13);

var _MenuContainer2 = _interopRequireDefault(_MenuContainer);

var _MenuView = __webpack_require__(11);

var _MenuView2 = _interopRequireDefault(_MenuView);

var _AddItem = __webpack_require__(9);

var _AddItem2 = _interopRequireDefault(_AddItem);

var _Item = __webpack_require__(4);

var _Item2 = _interopRequireDefault(_Item);

var _MediaItem = __webpack_require__(8);

var _MediaItem2 = _interopRequireDefault(_MediaItem);

var _NextItem = __webpack_require__(7);

var _NextItem2 = _interopRequireDefault(_NextItem);

var _PreviousItem = __webpack_require__(6);

var _PreviousItem2 = _interopRequireDefault(_PreviousItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Menu = function (_ControlledComponent) {
  _inherits(Menu, _ControlledComponent);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focusedKey: undefined,
      isOpen: false,
      id: _reactSelection.IdManager.generateId()
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appendToNode = _props.appendToNode,
          _trigger = _props.trigger,
          defaultPlacement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          popperModifiers = _props.popperModifiers,
          arrow = _props.arrow,
          children = _props.children,
          onChange = _props.onChange,
          zIndex = _props.zIndex,
          menuProps = _objectWithoutProperties(_props, ['appendToNode', 'trigger', 'placement', 'eventsEnabled', 'popperModifiers', 'arrow', 'children', 'onChange', 'zIndex']);

      var _getControlledState = this.getControlledState(),
          id = _getControlledState.id,
          isOpen = _getControlledState.isOpen,
          focusedKey = _getControlledState.focusedKey;

      return _react2.default.createElement(
        _MenuContainer2.default,
        {
          id: id,
          isOpen: isOpen,
          focusedKey: focusedKey,
          onStateChange: this.setControlledState,
          appendToNode: appendToNode,
          placement: defaultPlacement,
          eventsEnabled: eventsEnabled,
          popperModifiers: popperModifiers,
          zIndex: zIndex,
          onChange: onChange,
          trigger: function trigger(_ref2) {
            var getTriggerProps = _ref2.getTriggerProps,
                triggerRef = _ref2.triggerRef;

            var referencedTrigger = _trigger({ ref: triggerRef });

            return (0, _react.cloneElement)(referencedTrigger, getTriggerProps(referencedTrigger.props));
          }
        },
        function (_ref3) {
          var getMenuProps = _ref3.getMenuProps,
              getItemProps = _ref3.getItemProps,
              getPreviousItemProps = _ref3.getPreviousItemProps,
              getNextItemProps = _ref3.getNextItemProps,
              menuRef = _ref3.menuRef,
              placement = _ref3.placement;
          return _react2.default.createElement(
            _MenuView2.default,
            getMenuProps(_extends({ placement: placement, arrow: arrow, menuRef: menuRef }, menuProps)),
            _react.Children.map(children, function (child) {
              var _child$props = child.props,
                  textValue = _child$props.textValue,
                  disabled = _child$props.disabled,
                  childChildren = _child$props.children;

              var key = child.key;

              /**
               * Children with the `disabled` prop are not selectable
               */
              if (disabled) {
                return child;
              }

              if (child.type === _AddItem2.default || child.type === _Item2.default || child.type === _MediaItem2.default || child.type === _NextItem2.default || child.type === _PreviousItem2.default) {
                /**
                 * Automatically apply `textValue` if children is a string
                 */
                var childrenTextValue = typeof childChildren === 'string' ? childChildren : undefined;

                var itemPropMapper = getItemProps;

                if (child.type === _NextItem2.default) {
                  itemPropMapper = getNextItemProps;
                } else if (child.type === _PreviousItem2.default) {
                  itemPropMapper = getPreviousItemProps;
                }

                return (0, _react.cloneElement)(child, itemPropMapper(_extends({
                  key: key,
                  textValue: textValue || childrenTextValue,
                  focused: focusedKey === key,
                  children: childChildren
                }, child.props)));
              }

              return child;
            })
          );
        }
      );
    }
  }]);

  return Menu;
}(_reactSelection.ControlledComponent);

Menu.propTypes = {
  /**
   * Animate opening of Menu
   */
  animate: _propTypes2.default.bool,
  /**
   * Appends the menu to the provided element
   */
  appendToNode: _propTypes2.default.instanceOf(Element),
  /**
   * Whether to include an arrow on the visible arrow
   */
  arrow: _propTypes2.default.bool,
  /**
   * Menu Items you want to display. All children require a `key` prop
   */
  children: _propTypes2.default.node,
  /**
   * Whether Popper.js should update based on DOM resize events
   */
  eventsEnabled: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  /**
   * Controls visibility of menu
   */
  isOpen: _propTypes2.default.bool,
  /**
   * The currently focused item
   */
  focusedKey: _propTypes2.default.string,
  /**
   * Returns all controlled state. Used for controlling usage.
   */
  onStateChange: _propTypes2.default.func,
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.ref - Callback to retrieve the trigger elements ref
   */
  trigger: _propTypes2.default.func,
  /**
   * Callback for when a menu item has been selected by keyboard or mouse
   * @param {String} selectedKey - The key of the selected item
   */
  onChange: _propTypes2.default.func,
  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   **/
  placement: _propTypes2.default.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),
  /**
   * Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options)
   */
  popperModifiers: _propTypes2.default.object,
  /**
   * The z-index of the popper.js placement container
   */
  zIndex: _propTypes2.default.number
};
Menu.defaultProps = {
  animate: true,
  eventsEnabled: true,
  appendToNode: document.body
};
exports.default = Menu;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-modals");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-tooltips");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("react-portal");

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("react-popper");

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuContainer = __webpack_require__(13);

Object.defineProperty(exports, 'MenuContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuContainer).default;
  }
});

var _Menu = __webpack_require__(24);

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _AddItem = __webpack_require__(9);

Object.defineProperty(exports, 'AddItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddItem).default;
  }
});

var _HeaderIcon = __webpack_require__(19);

Object.defineProperty(exports, 'HeaderIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HeaderIcon).default;
  }
});

var _HeaderItem = __webpack_require__(18);

Object.defineProperty(exports, 'HeaderItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HeaderItem).default;
  }
});

var _Item = __webpack_require__(4);

Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Item).default;
  }
});

var _ItemMeta = __webpack_require__(17);

Object.defineProperty(exports, 'ItemMeta', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemMeta).default;
  }
});

var _MediaBody = __webpack_require__(16);

Object.defineProperty(exports, 'MediaBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MediaBody).default;
  }
});

var _MediaFigure = __webpack_require__(15);

Object.defineProperty(exports, 'MediaFigure', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MediaFigure).default;
  }
});

var _MediaItem = __webpack_require__(8);

Object.defineProperty(exports, 'MediaItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MediaItem).default;
  }
});

var _NextItem = __webpack_require__(7);

Object.defineProperty(exports, 'NextItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NextItem).default;
  }
});

var _PreviousItem = __webpack_require__(6);

Object.defineProperty(exports, 'PreviousItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PreviousItem).default;
  }
});

var _MenuView = __webpack_require__(11);

Object.defineProperty(exports, 'MenuView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuView).default;
  }
});

var _Separator = __webpack_require__(14);

Object.defineProperty(exports, 'Separator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Separator).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ])));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zendeskgarden/react-menus/dist/index.js
// module id = 360
// module chunks = 7